import assetsBase from '@exodus/assets-base'
import { cleanInput } from '@exodus/basic-utils'
import { getUrlWithOrderId, joinUrl, omitUndefinedValues } from '../utils.js'
import { ORDER_TYPES, PROVIDERS } from '../constants.js'
import moonpayAdapter from './adapter.js'
import { DEFAULT_CRYPTO_PRECISION, ENABLED_ASSETS } from './constants.js'

const assets = assetsBase.default || assetsBase

export const getWidgetUrl = ({
  apiKey,
  assets: assets_ = ENABLED_ASSETS,
  fromAmount,
  fromAsset,
  fromAssetPrecision = DEFAULT_CRYPTO_PRECISION,
  finalUrl,
  orderId,
  paymentMethod,
  themeId,
  toAmount,
  toAsset = [],
  toAssetPrecision = DEFAULT_CRYPTO_PRECISION,
  type = ORDER_TYPES.buy,
  url = `https://${type === ORDER_TYPES.sell ? 'sell' : 'buy'}.moonpay.com/`,
  walletAddress,
  origin,
} = {}) => {
  if (!ORDER_TYPES[type]) {
    throw new Error(`Invalid order type "${type}"`)
  }

  if (!apiKey) {
    throw new Error('`apiKey` is required')
  }

  if (fromAmount && toAmount) {
    throw new Error('`fromAmount` and `toAmount` are mutually exclusive')
  }

  if (fromAmount && !fromAsset) {
    throw new Error('`fromAsset` is required when `fromAmount` is provided')
  }

  if (toAmount && toAsset.length === 0) {
    throw new Error('`toAsset` is required when `toAmount` is provided')
  }

  const isBuyType = type === ORDER_TYPES.buy
  const toAssets = toAsset.map((asset) =>
    (isBuyType ? moonpayAdapter.fromExodusToProviderAsset(asset, assets_) : asset).toLowerCase()
  )

  const quoteCurrencyAmount = toAmount ? cleanInput(String(toAmount), toAssetPrecision) : toAmount
  const baseCurrencyAmount = fromAmount
    ? cleanInput(String(fromAmount), fromAssetPrecision)
    : fromAmount

  const searchParameters = new URLSearchParams(
    omitUndefinedValues({
      apiKey,
      baseCurrencyAmount,
      externalTransactionId: orderId,
      redirectURL: getUrlWithOrderId(
        orderId,
        finalUrl,
        omitUndefinedValues({ provider: PROVIDERS.moonpay, origin })
      ),
      themeId,
      ...(isBuyType
        ? {
            baseCurrencyCode: fromAsset?.toLowerCase(),
            currencyCode: toAssets.length === 1 ? toAssets[0] : undefined,
            defaultCurrencyCode: toAssets.length > 1 ? toAssets[0] : undefined,
            paymentMethod,
            quoteCurrencyAmount,
            showOnlyCurrencies: toAssets.length > 1 ? toAssets.join(',') : undefined,
            walletAddress,
          }
        : {
            baseCurrencyCode: moonpayAdapter.fromExodusToProviderAsset(assets[fromAsset], assets_),
            quoteCurrencyCode: toAssets[0],
            refundWalletAddress: walletAddress,
          }),
    })
  )

  return joinUrl(url, `?${searchParameters}`)
}
